import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import moment from "moment";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";

const DateRangePicker = ({ value = null, onChange }) => {
  const inputRef = useRef(null);
  const [placeholder, setPlaceholder] = useState("Choose date range");
  const isInitializingRef = useRef(true);

  useEffect(() => {
    const $input = $(inputRef.current);

    $input.daterangepicker(
      {
        autoUpdateInput: false,
        showDropdowns: true,
        opens: "left",
        locale: {
          format: "DD/MM/YY",
        },
      },
      (start, end) => {
        const formattedRange = `${start.format("DD/MM/YY")} - ${end.format("DD/MM/YY")}`;
        setPlaceholder(formattedRange);
        // Only call onChange if not initializing
        if (onChange && !isInitializingRef.current) {
          onChange({ start: start.format("YYYY-MM-DD"), end: end.format("YYYY-MM-DD") });
        }
      }
    );

    // Mark initialization as complete after a short delay
    const timer = setTimeout(() => {
      isInitializingRef.current = false;
    }, 100);

    return () => {
      clearTimeout(timer);
      if ($input.data("daterangepicker")) {
        $input.data("daterangepicker").remove();
      }
    };
  }, [onChange]);

  useEffect(() => {
    if (value) {
      // Parse the date range string (format: YYYY-MM-DD.YYYY-MM-DD)
      const [startDate, endDate] = value.split('.');
      if (startDate && endDate) {
        const picker = $(inputRef.current).data("daterangepicker");
        if (picker) {
          const start = moment(startDate, "YYYY-MM-DD");
          const end = moment(endDate, "YYYY-MM-DD");
          if (start.isValid() && end.isValid()) {
            isInitializingRef.current = true;
            picker.setStartDate(start);
            picker.setEndDate(end);
            setPlaceholder(`${start.format("DD/MM/YY")} - ${end.format("DD/MM/YY")}`);
            // Reset initialization flag
            setTimeout(() => {
              isInitializingRef.current = false;
            }, 100);
          }
        }
      }
    } else {
      setPlaceholder("Choose date range");
    }
  }, [value]);

  return (
    <div className="daterangepicker-container">
      <input
        type="text"
        ref={inputRef}
        className="form-control daterangepicker-input"
        placeholder={placeholder}
      />
      <span className="date-icon" onClick={() => inputRef.current?.click()}>
        <img
          src="/images/date-range-icon.svg"
          alt="Icon"
          style={{ width: 24, height: 24 }}
        />
      </span>
    </div>
  );
};

export default DateRangePicker;
